export const FUNCTIONALITY = "catalog_forecast_manager";

export const PERIOD_STATUS = Object.freeze({
    INITIAL: "INITIAL",
    STARTED: "STARTED",
    SUBMITTED: "SUBMITTED",
    RECHALLENGED: "RECHALLENGED"
});

export const COMPONENT_STATUS = Object.freeze({
    ACTIVE: "Active",
    OBSOLETE: "Obsolete",
    CANCELLED: "Cancelled"
});



// WEBPACK FOOTER //
// ./src/components/catalogForcast/constants.js